<template>
  <div class="service-section">
    <div class="service-section-top">
      <p class="service-section-title">
        <span>{{ this.label }}</span>
      </p>
    </div>
    <div class="service-section-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceSection',
  props: {
    label: {
      type: String
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
